/* batida-set-card.js: the "set for N people" product card follows the chosen variant (6.10.2026, Halloween w biurze).
   Loaded by sections/product.liquid only for products whose variants have custom.zestaw_dane. Every per-variant piece
   (contents list + summary, the per-person / "osobno" price line) is rendered server-side for each variant with
   data-bset-v="<variant id>"; this shows the chosen one and hides the rest. The chosen variant comes from
   theme:variant:change, and - because Pipeline does not always fire it here (see batida-loyalty.js) - from a re-read of
   the product form's id field shortly after any change or click in the buy box (custom.js writes the new id there),
   with the checked option radio (data-bset-vid) as the fallback. The variant buttons themselves are the theme's own
   radios; nothing here changes the variant. */
(function () {
  'use strict';
  var D = document;

  function known(id) {
    if (!id) return false;
    return !!D.querySelector('[data-bset-v="' + String(id).replace(/[^0-9]/g, '') + '"]');
  }

  function show(id) {
    if (!known(id)) return;
    id = String(id);
    var els = D.querySelectorAll('[data-bset-v]');
    for (var i = 0; i < els.length; i++) els[i].hidden = els[i].getAttribute('data-bset-v') !== id;
    perPerson(id);
  }

  /* 14.10.2026 (Aleksandra, Catering Basic / Premium): the per-person add-on in "Dodaj do zamówienia" (plate + wooden
     cutlery; snippets/batida-variant-contents.liquid puts its variant id in data-bset-addon-pp, catering template only) gets
     as many pieces as the chosen variant has people (data-bset-os: 10 osób = 10 sets). It sets the add-on's own hidden
     quantity input (.cross-product__input, the one assets/batida-drawer.js sends to /cart/add.js) and its stepper
     display, then fires "change" so the button total is recounted (batida-pdp-custom.js). Only when the number of
     people changes (or on load) - the customer can still change it with - / + afterwards. No data-bset-addon-pp: nothing. */
  var ppLast = null;
  function perPerson(id) {
    var root = D.querySelector('[data-bset-addon-pp]');
    if (!root || !id || id === ppLast) return;
    var v = D.querySelector('.bset__v[data-bset-v="' + id + '"]');
    var n = v ? parseInt(v.getAttribute('data-bset-os'), 10) : 0;
    if (!n || n < 1) return;
    var cb = D.querySelector('[data-perso-v2] .cross-product__checkbox[data-variant-id="' + root.getAttribute('data-bset-addon-pp') + '"]');
    var box = cb && cb.closest('.batida-perso-expanded');
    var inp = box && box.querySelector('.cross-product__input');
    if (!inp) return;
    ppLast = id;
    inp.value = String(n);
    var disp = box.querySelector('.batida-perso-stepper__display');
    if (disp) disp.textContent = String(n);
    try { inp.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
    relabel(box, n);
    if (!inp.__bsetRelabel) {   // the customer's - / + afterwards: the row follows the quantity
      inp.__bsetRelabel = true;
      inp.addEventListener('change', function () { relabel(box, parseInt(inp.value, 10) || 1); });
    }
  }

  /* 21.10 (Aleksandra): the add-on's row said "Ekologiczne naczynia, 1 osoba" and "+ 2,00 zł" although N sets were
     added. The row now says "Talerze i sztućce dla 20 osób" and "+ 40,00 zł" (unit price read once from the row). */
  function plForm(n, one, few, many) { var t = n % 10, h = n % 100; return n === 1 ? one : (t >= 2 && t <= 4 && (h < 12 || h > 14)) ? few : many; }
  function relabel(box, n) {
    var row = box && box.previousElementSibling;
    if (!row || !row.classList.contains('batida-perso-row')) return;
    var en = /^en/i.test(D.documentElement.lang || '');
    var title = row.querySelector('.batida-perso-title'), sub = row.querySelector('.batida-perso-sub'), price = row.querySelector('.batida-perso-price-col');
    if (title && title.firstChild && title.firstChild.nodeType === 3) {
      if (title.__bsetOrig == null) title.__bsetOrig = title.firstChild.nodeValue;
      title.firstChild.nodeValue = n > 1 ? (en ? 'Plates and cutlery for ' + n + ' people ' : 'Talerze i sztućce dla ' + n + ' osób ') : title.__bsetOrig;
    }
    if (sub) { if (sub.__bsetOrig == null) sub.__bsetOrig = sub.textContent; sub.textContent = n > 1 ? (en ? 'Eco tableware, ' + n + ' sets' : 'Ekologiczne naczynia, ' + n + ' ' + plForm(n, 'komplet', 'komplety', 'kompletów')) : sub.__bsetOrig; }
    if (price) {
      if (price.__bsetUnit == null) {
        var m = (price.textContent || '').replace(/\s/g, '').match(/([\d.]+),(\d{2})|([\d,]+)\.(\d{2})/);
        price.__bsetUnit = m ? (m[1] ? parseFloat(m[1].replace(/\./g, '') + '.' + m[2]) : parseFloat(m[3].replace(/,/g, '') + '.' + m[4])) : 0;
        price.__bsetOrig = price.textContent;
      }
      if (!price.__bsetUnit) return;
      var tot = (Math.round(price.__bsetUnit * n * 100) / 100).toFixed(2);
      price.textContent = n > 1 ? '+ ' + (en ? tot : tot.replace('.', ',')) + ' zł' : price.__bsetOrig;
    }
  }

  function current() {
    var f = D.querySelector('.product__inner form[action*="/cart/add"] [name="id"]') || D.querySelector('form[action*="/cart/add"] [name="id"]');
    if (f && known(f.value)) return f.value;
    var r = D.querySelector('.product__inner input[type="radio"][data-bset-vid]:checked');
    return r ? r.getAttribute('data-bset-vid') : null;
  }

  D.addEventListener('theme:variant:change', function (e) {
    var v = e.detail && e.detail.variant;
    if (v && v.id) show(v.id);
  });

  var t1 = null, t2 = null;
  function recheck(e) {
    if (e && e.target && e.target.closest && !e.target.closest('.product__inner, .batida-sticky-atc, #batida-sticky-atc-d')) return;
    clearTimeout(t1); clearTimeout(t2);
    t1 = setTimeout(function () { show(current()); }, 120);
    t2 = setTimeout(function () { show(current()); }, 600);
  }
  D.addEventListener('change', recheck, true);
  D.addEventListener('click', recheck, true);

  function init() { show(current()); setTimeout(function () { ppLast = null; show(current()); }, 1500); }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', init); else init();
})();
